import { Link } from "@tvg/fuse/link";
import classNames from "classnames";
import React from "react";
import styles from "./MenuIconLink.module.css";

export interface MenuIconLinkProps {
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
  href: string;
  icon?: React.ReactElement;
}

const MenuIconLink: React.FC<MenuIconLinkProps> = ({
  children,
  className,
  dataTestId,
  href,
  icon,
}) => (
  <>
    <Link
      centreAlign={false}
      className={classNames(
        styles.menuIconLink,
        "slide-out-menu__icon-link",
        className,
      )}
      dataTestId={dataTestId}
      disabled={false}
      href={href}
      icon={icon}
      iconRight={false}
      isButton={false}
      size="large"
      standalone={false}
      underline={false}
      white={false}
      iconColour="var(--color-global-black)"
    >
      {children}
    </Link>
  </>
);

export default MenuIconLink;
